import {IBlock} from '../../../../models';
import {Attachment} from './types';
import {BLOCK_TYPE} from '../../constants';

const ATTACHMENT_TYPE: any = [BLOCK_TYPE.SQL, BLOCK_TYPE.TABLEAU, BLOCK_TYPE.EXTERNAL_FILE];

export const blocksToOptions = (blocks: IBlock[]): Attachment[] => {
  return blocks.reduce((acc: Attachment[], block: IBlock) => {
    const {uid, name} = block;

    if (!uid || !name) {
      return acc;
    }

    if (ATTACHMENT_TYPE.includes(block.type)) {
      switch (block.type) {
        case BLOCK_TYPE.SQL:
          /*
           * If a block type has multiple export options, give them the same key,
           *   because one block can be exported only in one format.
           */
          acc.push({
            key: uid,
            unique_key: `csv_${uid}`,
            value: `{{ ${name}.export(file_format='csv') }}`
          });
          acc.push({
            key: uid,
            unique_key: `xlsx_${uid}`,
            value: `{{ ${name}.export(file_format='xlsx') }}`
          });
          break;
        case BLOCK_TYPE.TABLEAU:
          acc.push({ key: `tableau_${uid}`, value: `{{ ${name}.export() }}` });
          break;
        case BLOCK_TYPE.EXTERNAL_FILE:
          acc.push({ key: `external_file_${uid}`, value: `{{ ${name}.export() }}` });
          break;
      }
    }
    return acc;
  }, []);
}

export const getSourceBlocks = (blocks: any[]): any[] => {
  /*
   * TODO: find a better solution to filter out these blocks in general (used for KPI Cards as well)
   *
   * NOT `SQL` blocks with the names `condition_check` or `mail_merge` (used in reports)
   */
  if (!blocks?.length) {
    return [];
  }
  return blocks.filter((b: any) =>
    !(b.type === BLOCK_TYPE.SQL && ['condition_check', 'mail_merge'].includes(b.name))
  );
};

export const setInitialValue = (value: string[] | undefined | null, options: Attachment[]): Attachment[] => {
  const initialValue: Attachment[] = [];

  if (!value) {
    return initialValue;
  } else if (!value.length) {
    return initialValue;
  }

  return value.reduce((acc: Attachment[], v: string) => {
    const found = options.find((a: Attachment) => v.includes(a.value));

    if (found) {
      acc.push(found)
    } else {
      const attachment: Attachment = {
        key: null,
        value: v
      }; // custom attachments
      acc.push(attachment);
    }

    return acc;
  }, []);
};

export const getFilename = (attachment: string): string => {
  /*
   * We assume that attachment is a URL (from S3) and the filename is the last part of the pathname
   */
  try {
    const url = new URL(attachment || '');

    const parts = url.pathname.split('/');

    if (parts.length > 0) {
      return parts[parts.length - 1];
    }
  } catch (error: any) {
    return attachment;
  }
  return '';
};

export const getFilenameExtension = (filename: string): string => {
  const parts = filename.split('.');

  if (parts.length > 1) {
    return parts[parts.length - 1]; // xlsx, csv, png, etc.
  }
  return '';
};

export const attachmentIsURL = (attachment: string): boolean => {
  try {
    const url = new URL(attachment || '');

    return true;
  } catch (error: any) {
    return false;
  }
}

export const attachmentIsNull = (attachment: string): boolean => {
  return attachment === null || ((attachment || '') === 'None');
};
